export default function isAdmin(user) {
  return user && Array.isArray(user.acl) && user.acl.includes('admin');
}
